// extracted by mini-css-extract-plugin
module.exports = {"acard_faq_table":"en_acard_faq_table__SfEfZ","acard_faq_td":"en_acard_faq_td__nR3vK","acard_faq_th":"en_acard_faq_th__32PkE"};